module.exports = __webpack_public_path__ + "images/307c53fec45eba66801136eb793178af.svg";